module.exports = __webpack_public_path__ + "static/media/logo_capifrance.29e05d83.png";